import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle, FaFilePdf } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Invoices.css"; // Asegúrate de tener este archivo CSS para los estilos

const ConsultInvoices = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [listInvoices, setListInvoices] = useState([]);
  const [listInvoicesFiltered, setListInvoicesFiltered] = useState([]);

  const typeMessages = {
    active: "¡Factura activada con èxito",
    inactive: "¡Factura cancelada con èxito",
    error: "Error en el mensaje del modal",
  };

  const API_URL = process.env.REACT_APP_API_URL;

  const formatLocalDate = (date) => {
    if (!date) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const today = formatLocalDate(new Date());
  const [filterField, setFilterField] = useState("consecutivo");
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [hasCustomRange, setHasCustomRange] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentRecords, setCurrentRecords] = useState([]);
  const recordsPerPage = 20; // Puedes cambiarlo según necesidad

  // Calcular registros de la página actual
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  // Calcular total de páginas
  const totalPages = Math.max(
    1,
    Math.ceil(listInvoicesFiltered.length / recordsPerPage),
  );

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    getInvoices(today, today);
  }, []);

  useEffect(() => {
    setCurrentPage(1); // Resetear a la primera página al filtrar
  }, [listInvoicesFiltered]);

  useEffect(() => {
    setCurrentRecords([]);
    setTimeout(() => {
      setCurrentRecords(
        listInvoicesFiltered.slice(indexOfFirstRecord, indexOfLastRecord),
      );
    }, 500);
  }, [
    listInvoicesFiltered,
    currentPage,
    indexOfFirstRecord,
    indexOfLastRecord,
  ]);

  const openModalSuccess = (type) => {
    switch (type) {
      case "active":
        setMessageModal(typeMessages.active);
        break;
      case "inactive":
        setMessageModal(typeMessages.inactive);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const getInvoices = (fechaInicio, fechaFin) => {
    setIsLoading(true);

    const params = new URLSearchParams({
      fechaInicio,
      fechaFin,
    });

    fetch(`${API_URL}/invoices?${params.toString()}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        setIsLoading(false);

        if (result.result) {
          setListInvoices(result.result);
          setListInvoicesFiltered(result.result);
        } else {
          setListInvoices([]);
          setListInvoicesFiltered([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const searchList = (type) => {
  setIsLoading(true);

  const params = new URLSearchParams({
    type,
    value: searchTerm,
  });

  fetch(`${API_URL}/filter-invoices?${params.toString()}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((result) => {
      setIsLoading(false);

      console.log("RESULT SEARCH:", result);

      if (result.result) {
        setListInvoices(result.result);
        setListInvoicesFiltered(result.result);
      } else {
        setListInvoices([]);
        setListInvoicesFiltered([]);
      }
    })
    .catch((error) => {
      setIsLoading(false);
      console.error(error);
    });
};

  const changeStateInvoice = (consecutivo, action) => {
    fetch(`${API_URL}/update-state-invoice/${consecutivo}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action }),
    })
      .then((response) => response.json())
      .then(() => {
        openModalSuccess(action === "approved" ? "active" : "inactive");
        getInvoices(today, today);
      })
      .catch((error) =>
        console.error("Error al actualizar el estado de la factura:", error),
      );
  };

  const handleFilterFieldChange = (value) => {
    setFilterField(value);
    setSearchTerm("");
    setListInvoicesFiltered(listInvoices);
  };

  return (
    <div className="invoices-container">
      {/* Tabla */}
      <div className="table-container-invoices table-container">
        <h2>Consulta de facturas</h2>
        <div className="filter-container">
          <select
            value={filterField}
            onChange={(e) => handleFilterFieldChange(e.target.value)}
          >
            <option value="consecutivo"># Consecutivo</option>
            <option value="no_contrato"># Contrato</option>
            <option value="nombre_establecimiento">
              Nombre del establecimiento
            </option>
            <option value="fecha_factura">Fecha factura</option>
          </select>
          {filterField === "fecha_factura" ? (
            <DatePicker
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={(dates) => {
                const [start, end] = dates;

                setStartDate(start);
                setEndDate(end);

                if (start && end) {
                  getInvoices(formatLocalDate(start), formatLocalDate(end));
                }
              }}
              isClearable
              dateFormat="yyyy-MM-dd"
              placeholderText="Seleccionar rango de fechas"
              shouldCloseOnSelect={false}
            />
          ) : (
            <div className="container-filter">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button onClick={() => searchList(filterField)}>Buscar</button>
            </div>
          )}
        </div>
        <table>
          <thead>
            <tr>
              <th># Consecutivo</th>
              <th>Estado de la factura</th>
              <th># Contrato</th>
              <th>Tipo de venta express</th>
              <th>Nombre del establecimiento</th>
              <th>Representante Legal</th>
              <th>Dirección</th>
              <th>Correo</th>
              <th>Fecha de la factura</th>
              <th>Hora</th>
              <th>Placa del vehículo</th>
              <th>Nombre del conductor</th>
              <th>Metodo de pago</th>
              <th>Total pagado</th>
              <th>Descripción</th>
              <th>Factura</th>
              <th>Manifiesto de custodia</th>
              <th>Cambiar estado de factura</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.map((invoice) => {
              const wasteDetails = invoice.detalles
                ? JSON.parse(invoice.detalles)
                : [];

              return (
                <React.Fragment key={invoice.consecutivo}>
                  {/* Fila principal */}
                  <tr>
                    <td>{invoice.consecutivo}</td>
                    <td>{invoice.state_invoice}</td>
                    <td>{invoice.no_contrato}</td>
                    <td>{invoice.type_sale}</td>
                    <td>{invoice.nombre_establecimiento}</td>
                    <td>{invoice.representante}</td>
                    <td>{invoice.direccion}</td>
                    <td>{invoice.correo}</td>
                    <td>{invoice.fecha_factura}</td>
                    <td>{invoice.time_factura}</td>
                    <td>{invoice.vehicle_plate}</td>
                    <td>{invoice.driver_name}</td>
                    <td>{invoice.payment_method}</td>
                    <td>{invoice.total_sale}</td>
                    <td>{invoice.description}</td>
                    <td>
                      <a
                        href={invoice.pdf_factura}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFilePdf className="delete-icon" />
                      </a>
                    </td>
                    <td>
                      <a
                        href={invoice.pdf_manifest}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFilePdf className="black-icon" />
                      </a>
                    </td>
                    <td>
                      <FaCheckCircle
                        className="edit-icon"
                        onClick={() =>
                          changeStateInvoice(invoice.consecutivo, "approved")
                        }
                      />
                      <FaTimesCircle
                        className="delete-icon"
                        onClick={() =>
                          changeStateInvoice(invoice.consecutivo, "canceled")
                        }
                      />
                    </td>
                  </tr>

                  {/* Fila adicional con detalles */}
                  <tr>
                    <td colSpan="18" style={{ backgroundColor: "#f9f9f9" }}>
                      <strong>Residuos:</strong>
                      <ul style={{ margin: 0, paddingLeft: "1rem" }}>
                        {wasteDetails.length > 0 ? (
                          wasteDetails.map((item, idx) => (
                            <li key={idx}>
                              {item.wasteType} - {item.wasteAmount}Kg
                            </li>
                          ))
                        ) : (
                          <li>No hay residuos registrados.</li>
                        )}
                      </ul>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <div className="pagination">
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1 || totalPages === 1}
          >
            ⏮ Primera
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ◀ Anterior
          </button>
          <span>
            Página {currentPage} de {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 1}
          >
            Siguiente ▶
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages || totalPages === 1}
          >
            Última ⏭
          </button>
        </div>
      </div>

      {isLoading && (
        <div className="modal-loading">
          <div className="spinner"></div>
          <p>Cargando contratos...</p>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-success">
          <div className="modal-content">
            <FaCheckCircle size={100} color="green" className="modal-icon" />
            <h1>{messageModal}</h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultInvoices;
